var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDxFeed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 16,
    viewBox: "0 0 25 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.56251 6.6324H11.3773V5.294L4.9748 1.8696H11.3773V0H0.101562V6.6324H2.03859V2.5388L2.08003 2.5584L9.56251 6.6324Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5292 6.6324V0H13.2129V1.8696H19.6154L13.2129 5.294V6.6324H15.048L22.5719 2.52V6.6324H24.5292Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9009 12.9694H13.2129V14.839H24.5292V8.22656H22.5719V12.1626L22.5516 12.143L15.3335 8.22656H13.2129V9.38656L19.9009 12.9694Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.20703V10.1158H6.62668L0 13.6782V16.0006L9.33869 10.9606V14.859H11.3163V8.20703H0Z",
    fill: "#4BB390"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDxFeed);
export default __webpack_public_path__ + "static/media/dxFeed.5bd3f1d258b2914c562f84f514005cca.svg";
export { ForwardRef as ReactComponent };